import { render, staticRenderFns } from "./static-report.vue?vue&type=template&id=05b2db42&scoped=true"
import script from "./static-report.vue?vue&type=script&lang=ts"
export * from "./static-report.vue?vue&type=script&lang=ts"
import style0 from "./static-report.vue?vue&type=style&index=0&id=05b2db42&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b2db42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05b2db42')) {
      api.createRecord('05b2db42', component.options)
    } else {
      api.reload('05b2db42', component.options)
    }
    module.hot.accept("./static-report.vue?vue&type=template&id=05b2db42&scoped=true", function () {
      api.rerender('05b2db42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/final-report/static-report.vue"
export default component.exports